import cn from 'classnames';
import { type ReactNode } from 'react';
import type React from 'react';
import Button from './Button';

type P = React.ComponentProps<typeof Button> & {
  onClick: () => void;
  className?: string;
  icon?: ReactNode;
};

const ActionButton = ({ onClick, className, icon, ...rest }: P) => (
  <Button
    {...rest}
    item={{
      shape: 'round',
      className: cn('action-button', className),
      onClick,
      icon,
    }}
  />
);

export default ActionButton;
